import { currency_list } from 'src/consumer/constants'

export const getPriceStringBusinessPlan = (currency, price) => {
  if (parseFloat(price)) {
    const symbol = currency_list.find((item) => item.code === currency?.toLowerCase())?.symbol
    return `${symbol} ${price} PEPM`
  }

  return ''
}
